var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"order-create__section"},[_c('div',{staticClass:"order-create__row custom-row order-wrap"},[_c('div',{staticClass:"custom-col custom-col--66 custom-col--md-100"},[_c('CustomizationOffer',{attrs:{"CO":_vm.CO,"orderData":_vm.orderData}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }